
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-construction-advertising/category/[...slug]",
      function () {
        return require("private-next-pages/new-construction-advertising/category/[...slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-construction-advertising/category/[...slug]"])
      });
    }
  